import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from "./shared/shared.module";
import { AgmCoreModule } from '@agm/core';

import { AppComponent } from './app.component';
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";
import { FullLayoutComponent } from "./layouts/full/full-layout.component";

import { ToastrModule } from 'ngx-toastr';
import { UiSwitchModule } from 'ngx-ui-switch';


import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { RouterModule, Routes } from '@angular/router';

import { LoginModule, provideBovedaLogin } from 'Login_Angular9_2.0';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false
};


import * as $ from 'jquery';
import { UsuarioInterceptor } from './interceptors/Usuario.interceptor';

import {SliderModule} from 'primeng/slider';
import { PasswordModule } from 'primeng/password';
import { NgSelectModule } from '@ng-select/ng-select';
import { MainService } from './services/main.service';

 


@NgModule({
  declarations: [
    AppComponent,
    FullLayoutComponent,
    ContentLayoutComponent,

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    SliderModule,
    NgbModule,
    ToastrModule.forRoot({
        positionClass: 'toast-top-center',
        timeOut: 90000,
        closeButton: true,
        preventDuplicates: true,
      }),
    UiSwitchModule,
    AgmCoreModule.forRoot({apiKey: 'AIzaSyDKXKdHQdtqgPVl2HI2RnUa_1bjCxRCQo4'}),
    PerfectScrollbarModule,
    PasswordModule,
    NgSelectModule,
    RouterModule
  ],
  providers: [
    MainService,
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    ...provideBovedaLogin({
      sistemaId: 26,              
      baseUrl: 'https://bovedav3.conade.gob.mx/servicios/api',           
      redirectUrl: 'https://simaf.conade.gob.mx/#/components/home',     
      version: '1.0.0',          
      environment: 'Producción', 
      productionEnvironmentName: 'Producción',
      showRegister: false
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}
